import { Feedback, Feedbacks } from "@/models/Feedback";
import { SWRResponse } from "swr";
import { useAPI } from "../useAPI";
import endpoints from "./feedbacks.endpoint";
import { FeedbacksResponse } from "./feedbacks.type";

export const useFeedbacks = (threadId: string): SWRResponse<Feedbacks> => {
  // 共通APIコール処理を使用
  return useAPI<FeedbacksResponse, Feedbacks>(
    endpoints.GET_FEEDBACKS(threadId),
    responseToModel,
    {
      fallbackData: new Feedbacks([]),
    },
  );
};

const responseToModel = (response: FeedbacksResponse): Feedbacks => {
  const items = response.feedbacks.map((item) =>
    new Feedback(
      item.id,
      item.messageId,
      item.score,
      item.comment,
    )
  );
  return new Feedbacks(items);
};
